
<template>
    <div>
        <router-view v-show="$route.meta.hasOwnProperty('detail') && $route.meta.detail"></router-view>
        <div class="wrap" v-show="!$route.meta.hasOwnProperty('detail') || !$route.meta.detail">
            <div class="container lnb">
                <div class="contents_wrap">
                    <div class="contents">
                        <div class="title">
                            {{ title }}
                            <el-button class="title_btn" type="primary" @click="$router.push('/magazine/ad/create')">등록</el-button>
                            <div class="clear"></div>
                        </div>
                        <magazine-ad-component></magazine-ad-component>

                    </div>
                    <page-footer></page-footer>
                </div>
            </div>
        </div>

    </div>
</template>


<script>
import MagazineAdComponent from "@/components/magazine/MagazineAdComponent";
export default {
    name: "AdMagazine", // 광고 매거진 목록
    components: {
        MagazineAdComponent,
    },
    created(){

    },
    mixins: [],
    data() {
        return{
            title: this.$route.meta.title,
        }
    },
    mounted() {
    },
    computed: {
    },
    watch: {
    },
    methods: {
    },
}
</script>
